import React, { useState } from 'react';
import { PlusCircleIcon } from '@heroicons/react/24/solid';
import ModalCoreCycleForm from '../moduleComponents/ModalCoreCycleForm';
import CardCoreCycle from '../moduleComponents/CardCoreCycle';
import { deleteCoreCycle } from '../core_services';

const HORIZON = 'strategy';

/**
 * Strategy horizon — ~3 year window. Same shell as purpose/tactical tabs;
 * expected to diverge over time (e.g. a "2-3 named focuses" sub-entity —
 * see core module design notes, 2026-08-19, not yet modeled).
 */
const CardSkeleton = () => (
  <div className="bg-white p-4 rounded-xl shadow animate-pulse">
    <div className="h-4 w-1/3 rounded bg-gray-200" />
    <div className="h-3 w-2/3 rounded bg-gray-100 mt-2" />
  </div>
);

const TabCoreStrategy = ({ cycles, loadCycles, frameworks, isLoading = false }) => {
  /** undefined = closed; null = create new; object = view/edit existing */
  const [cycleModal, setCycleModal] = useState(undefined);

  const handleSuccess = () => {
    loadCycles();
  };

  const handleDelete = async (id) => {
    await deleteCoreCycle(id);
  };

  return (
    <>
      {cycleModal !== undefined && (
        <ModalCoreCycleForm
          cycle={cycleModal}
          horizon={HORIZON}
          frameworks={frameworks}
          onClose={() => setCycleModal(undefined)}
          onSuccess={handleSuccess}
          onDelete={handleDelete}
        />
      )}

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
          <CardSkeleton />
          <CardSkeleton />
        </div>
      ) : cycles.length === 0 ? (
        <p className="text-gray-500 px-2">No strategy cycles registered yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
          {cycles.map((cycle) => (
            <CardCoreCycle key={cycle.id} cycle={cycle} onClick={() => setCycleModal(cycle)} />
          ))}
        </div>
      )}

      <button
        onClick={() => setCycleModal(null)}
        className="fixed bottom-20 right-6 bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg"
      >
        <PlusCircleIcon className="h-8 w-8" />
      </button>
    </>
  );
};

export default TabCoreStrategy;
